/**
 * Cross-tab logout beacon (emit side).
 *
 * On logout the tab writes a value to this per-origin localStorage key. The
 * browser fires a native `storage` event in every OTHER same-origin tab, which
 * they use to sign themselves out locally. The value must CHANGE on every write
 * or the `storage` event will not fire on a repeat logout, so we combine the
 * wall clock with a monotonic counter to guarantee uniqueness even for two
 * writes within the same millisecond.
 */
export const LOGOUT_BEACON_KEY = 'auth:logout'

let beaconCounter = 0

export const emitLogoutBeacon = (): void => {
  try {
    beaconCounter += 1
    window.localStorage.setItem(LOGOUT_BEACON_KEY, `${Date.now()}:${beaconCounter}`)
  } catch {
    // localStorage can throw (private mode / quota). A failed beacon only
    // degrades to the existing reactive 401 sign-out in other tabs — never
    // block the local logout on it.
  }
}
